var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 28,
    viewBox: "0 0 41 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8095 20L27.2601 14L16.8095 8V20ZM40.0868 4.34C40.3486 5.28 40.5298 6.54 40.6506 8.14C40.7916 9.74 40.852 11.12 40.852 12.32L40.9728 14C40.9728 18.38 40.6506 21.6 40.0868 23.66C39.5834 25.46 38.4155 26.62 36.6033 27.12C35.6569 27.38 33.9252 27.56 31.2672 27.68C28.6495 27.82 26.2533 27.88 24.0384 27.88L20.8367 28C12.3997 28 7.14422 27.68 5.07021 27.12C3.25796 26.62 2.09007 25.46 1.58667 23.66C1.3249 22.72 1.14368 21.46 1.02286 19.86C0.881908 18.26 0.8215 16.88 0.8215 15.68L0.700684 14C0.700684 9.62 1.02286 6.4 1.58667 4.34C2.09007 2.54 3.25796 1.38 5.07021 0.88C6.0166 0.62 7.7483 0.44 10.4063 0.32C13.0239 0.18 15.4201 0.12 17.6351 0.12L20.8367 0C29.2737 0 34.5293 0.32 36.6033 0.88C38.4155 1.38 39.5834 2.54 40.0868 4.34Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.4a3cb3ecdc2949077c61dcd962c8ce85.svg";
export { ForwardRef as ReactComponent };